import React from 'react'

export const BottomBorder = () => {
    return (
        <div className="bottomBorder">
            <div className="DotsWarpper">
                <div className="Dot">
                    <div className="material-icons" style={{fontSize: '17px'}}>
                        more_horiz
                    </div>
                </div>
            </div>
        </div>
    )
}
export default BottomBorder;